var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.FCLAdditionalFeeMaintenance"),
        width: "1140px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "surcharge-fcl-form-dialog details-view"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { ref: "pol", attrs: { label: _vm.$t("Pricing.POL") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { ref: "pod", attrs: { label: _vm.$t("Pricing.POD") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Direct") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "directType",
                            filterable: "",
                            cache: false,
                            clearable: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options": _vm.directTypeList,
                            "default-value": _vm.price.directType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.directType = p.code
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.price.directType === 3,
                            expression: "price.directType === 3"
                          }
                        ],
                        ref: "via",
                        attrs: {
                          required: _vm.price.directType === 3,
                          label: _vm.$t("Pricing.Via")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "via",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.via,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.via = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.TradeLane") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "region",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Region,
                            filterable: "",
                            "custom-label": function(item) {
                              return "" + item.name
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.region
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.region = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "eqType",
                        attrs: { required: "", label: _vm.$t("Pricing.EqType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "eqType",
                            "select-type":
                              _vm.selectTypeNames.basic_data_EQType,
                            "tag-name": "code",
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.price.eqType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.eqType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "currency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Currency")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Carrier") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return item.cmpIdx > 0
                                ? "[" + item.shortName + "]" + item.chineseName
                                : ""
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.BookingAgent") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingAgent",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { bookingAgent: true },
                            "custom-label": function(item) {
                              return "" + item.chineseName
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.bookingAgent
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.bookingAgent = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "payment",
                        attrs: {
                          required: "",
                          valid: _vm.$t("Message.PleaseSelect"),
                          label: _vm.$t("Pricing.PaymentTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "payment",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PAYMENT_TERMS,
                            filterable: "",
                            "default-value": _vm.price.payment
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.payment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "vat" },
                            model: {
                              value: _vm.price.vat,
                              callback: function($$v) {
                                _vm.$set(_vm.price, "vat", $$v)
                              },
                              expression: "price.vat"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Pricing.VatIncluded")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.COST_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "costVat",
                                disabled: _vm.price.vat,
                                type: "number"
                              },
                              on: { change: _vm.costVatChange },
                              model: {
                                value: _vm.costVat,
                                callback: function($$v) {
                                  _vm.costVat = $$v
                                },
                                expression: "costVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SELL_VAT") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "sellVat",
                                type: "number",
                                disabled: _vm.price.vat
                              },
                              on: { change: _vm.sellVatChange },
                              model: {
                                value: _vm.sellVat,
                                callback: function($$v) {
                                  _vm.sellVat = $$v
                                },
                                expression: "sellVat"
                              }
                            }),
                            _c("label", [_vm._v(" %")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.GenerateCharge") } },
                      [
                        _c("el-checkbox", {
                          attrs: { no: "generateCharge" },
                          model: {
                            value: _vm.price.generateCharge,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "generateCharge", $$v)
                            },
                            expression: "price.generateCharge"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "chargeScaleCode",
                        attrs: {
                          required: "",
                          valid: _vm.$t("FileHistory.PlsInput"),
                          label: _vm.$t("Pricing.FeeName")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargeScaleCode",
                            filterable: "",
                            cache: false,
                            "tag-name": "zhName",
                            "tag-value": "scaleCode",
                            "filter-tag-names": [
                              "zhName",
                              "scaleCode",
                              "enName"
                            ],
                            "static-options": _vm.chargeItems,
                            "default-value": _vm.price.chargeScaleCode
                          },
                          on: { parentCallBack: _vm.changeSurchargeScaleCode }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "chargeType",
                        attrs: {
                          required: "",
                          valid: _vm.$t("FileHistory.PlsInput"),
                          label: _vm.$t("Pricing.ChargeType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargeType",
                            "static-options": _vm.chargeTypes,
                            "tag-name": "label",
                            "tag-value": "value",
                            "default-value": _vm.price.chargeType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.chargeType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "freightType",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.PriceType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightType",
                            "static-options": _vm.priceTypes,
                            "tag-value": "code",
                            "default-value": _vm.price.freightType,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.freightType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ChargeUnit") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "unit",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_ChargeUnit,
                            "callback-method-type": "value",
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "default-value": _vm.price.unit
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.unit = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "20'" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "valid20",
                          attrs: {
                            no: "cost20",
                            required: false,
                            one: _vm.price.cost20,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sum20
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.cost20 = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sum20 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40'" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "valid40",
                          attrs: {
                            no: "cost40",
                            required: false,
                            one: _vm.price.cost40,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sum40
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.cost40 = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sum40 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40'HC" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "validHC",
                          attrs: {
                            no: "costhc",
                            required: false,
                            one: _vm.price.costhc,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sumhc
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.costhc = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sumhc = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "20'NOR" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "valid20nor",
                          attrs: {
                            no: "cost20nor",
                            required: false,
                            one: _vm.price.cost20nor,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sum20nor
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.cost20nor = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sum20nor = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "40'NOR" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "valid40nor",
                          attrs: {
                            no: "cost40nor",
                            required: false,
                            one: _vm.price.cost40nor,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sum40nor
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.cost40nor = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sum40nor = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "45'" } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "valid45",
                          attrs: {
                            no: "cost45",
                            required: false,
                            one: _vm.price.cost45,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.sum45
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.cost45 = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.sum45 = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.UnitPrice") } },
                      [
                        _c("pair-numeric-stepper", {
                          ref: "validCasePrice",
                          attrs: {
                            no: "costCasePrice",
                            required: false,
                            one: _vm.price.costCasePrice,
                            "one-prompt": _vm.$t("Pricing.Cost"),
                            "two-prompt": _vm.$t("Pricing.Sell"),
                            two: _vm.price.casePrice
                          },
                          on: {
                            onChangeOne: function(p) {
                              _vm.price.costCasePrice = p
                            },
                            onChangeTwo: function(p) {
                              _vm.price.casePrice = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          valid: _vm.$t("FileHistory.PlsInput"),
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            maxlength: 255
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "500px" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Dangerous") } },
                      [
                        _c("el-checkbox", {
                          staticStyle: { width: "190px" },
                          attrs: { no: "dangerous" },
                          model: {
                            value: _vm.price.dangerous,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "dangerous", $$v)
                            },
                            expression: "price.dangerous"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DangerousClass") } },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "classification",
                            filterable: "",
                            clearable: false,
                            disabled: !_vm.price.dangerous,
                            "static-options": _vm.dangerousClassData,
                            multiple: "",
                            "custom-label": function(item) {
                              return "" + item.classification
                            },
                            "show-custom-label-in-option": true,
                            "tag-value": "classification",
                            "default-multiple-value": _vm.dangerousClass
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.dangerousClass = [].concat(p.value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isCp && !_vm.isNew,
                        expression: "!isCp && !isNew"
                      }
                    ],
                    staticStyle: { "margin-right": "10px" }
                  },
                  [
                    _c("cargo-ag-grid", {
                      key: "22080103",
                      staticStyle: { flex: "1" },
                      attrs: {
                        "config-module": "22080103",
                        "grid-params": _vm.file.gridParams,
                        "grid-options": _vm.file.gridOptions,
                        "column-defs": _vm.file.columnDefs,
                        "row-data": _vm.file.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          return _vm.$set(_vm.file, "gridParams", $event)
                        },
                        "update:grid-params": function($event) {
                          return _vm.$set(_vm.file, "gridParams", $event)
                        },
                        gridReady: function(params) {
                          _vm.file.gridApi = params.api
                        }
                      }
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "margin-top": "10px"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "visible", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.file.cloudFile.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              no: "delFileEventHandler",
                              disabled: !_vm.hasSelectFile,
                              type: "danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delFileEventHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.file.cloudFile.visible,
          job: _vm.price,
          lob: _vm.file.cloudFile.lob,
          "should-encode-uuid": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.file.cloudFile, "visible", $event)
          },
          uploadDone: _vm.fileUploadSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }